export default {
      id: "shipment__mail-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/icons.svg#shipment__mail",
      toString: function () {
        return this.url;
      }
    }